import styled from "styled-components";

export const Container = styled.div`
  height: max-content;
  padding: 40px 0 0;
  border-radius: 10px;
  margin-right: 2rem;
  z-index: 2;

  .gx-product-item {
    overflow: visible;
    padding-bottom: 20px;
    margin-bottom: 0 !important;

    p,
    div,
    h4 {
      color: ${({ theme }) => theme.colors.textColor} !important;
    }
  }

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const ContainerImage = styled.div`
  height: 100%;
  width: 100%;
  ${(props) => props.hasTrailer && "cursor: pointer;"}

  .ant-card.gx-card-widget.gx-card-full.ant-card-bordered {
    margin: 0px;
  }

  .gx-user-wid-body {
    padding-bottom: 1rem;
  }

  .gx-card-widget {
    box-shadow: none;
  }

  @media (min-width: 1400px) and (max-width: 1600px) {
    img.course-thumb-img {
      max-height: 450px;
      object-fit: cover;
    }
  }

  @media (min-width: 1250px) and (max-width: 1400px) {
    img.course-thumb-img {
      max-height: 380px;
      object-fit: cover;
    }
  }

  @media (min-width: 700px) and (max-width: 1250px) {
    img.course-thumb-img {
      max-height: 350px;
      object-fit: cover;
    }
  }
`;

export const EnrollmentSection = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${(props) =>
    props.theme.colors.modalBackgroundColor} !important;

  padding: 2rem;

  .ant-btn-primary {
    width: 100%;
    height: 48px;
    margin-top: 2rem;
    font-size: 1rem;
    font-weight: bold;
    span {
      color: ${({ theme }) => theme.colors.btnTextColor} !important;
    }
  }
`;
